const flagJSON = {
    isTest: false,
    isDashboardEnabled: false,
    isCompanyTableEnabled: false,
    isAdditionalDataImportingEnabled: false,
    isOnSiteEnabled: false,
    isCustomerJourneyEnabled: false,
    isInterceptEnabled: false,
    isEmbedEnabled: false,
    isQrEnabled: false,
    isMultiDivisionEnabled: false,
    isDeliveryReportEnabled: false,
    isAdvancedCrossTabEnabled: false,
    isExhibitMeasurementEnabled: false,
    isRapidSurveysEnabled: false,
    isGeSurveyEmailEnabled: false,
    useSSO: false,
    isReseller: false,
    isCertificationEnabled: false,
}

class Client {
    constructor({
        clientId = 0,
        active = true,
        name = '',
        address = '',
        address2 = '',
        town = '',
        postcode = '',
        country = '',
        telephone = '',
        fax = '',
        timezone = '',
        mainContact = 0,
        flags = flagJSON,
        clearRespondentDetails = 13,
        locales = [],
        industry = [],
        surveyTypes = [],
        currencies = [],
        defaultCurrency = '',
        isGeLimitExempt = 1,
        dashboardStatus = 'v4',
    }) {
        this.clientId = clientId
        this.active = Boolean(active)
        this.name = name
        this.address = address
        this.address2 = address2
        this.town = town
        this.postcode = postcode
        this.country = country
        this.telephone = telephone
        this.fax = fax
        this.timezone = timezone
        this.mainContact = mainContact
        this.flags = { ...flagJSON, ...flags }
        this.clearRespondentDetails = parseInt(clearRespondentDetails, 10)
        this.locales = locales
        this.industry = industry
        this.surveyTypes = surveyTypes
        this.currencies = currencies
        this.defaultCurrency = defaultCurrency
        this.isGeLimitExempt = isGeLimitExempt
        this.dashboardStatus = dashboardStatus
    }

    toJSON = () => {
        const json = {
            clientId: this.clientId,
            active: this.active,
            name: this.name,
            address: this.address,
            address2: this.address2,
            town: this.town,
            postcode: this.postcode,
            country: this.country,
            telephone: this.telephone,
            fax: this.fax,
            timezone: this.timezone,
            mainContact: this.mainContact,
            flags: this.flags,
            clearRespondentDetails: this.clearRespondentDetails,
            locales: this.locales,
            industry: this.industry,
            surveyTypes: this.surveyTypes,
            currencies: this.currencies,
            defaultCurrency: this.defaultCurrency,
            isGeLimitExempt: this.isGeLimitExempt,
            dashboardStatus: this.dashboardStatus,
        }
        return json
    }
}

export default Client
